import React from 'react';

interface Props {
  width: number;
  height: number;
}

const SvgPromoCodeReg = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M78 18H18C15.24 18 13 20.24 13 23V73C13 75.76 15.24 78 18 78H78C80.76 78 83 75.76 83 73V23C83 20.24 80.76 18 78 18Z"
      fill="#95A4EF"
    />
    <path
      d="M18 19H78C80.2077 19 82 20.7923 82 23V73C82 75.2077 80.2077 77 78 77H18C15.7923 77 14 75.2077 14 73V23C14 20.7923 15.7923 19 18 19Z"
      stroke="url(#paint0_linear_51736_6310)"
      strokeOpacity="0.1"
      strokeWidth="2"
    />
    <g filter="">
      <path
        d="M74.97 72.0001H21.03C19.91 72.0001 19 71.2001 19 70.2101V37.6001C19 36.6101 19.91 35.8101 21.03 35.8101H74.97C76.09 35.8101 77 36.6101 77 37.6001V70.2101C77 71.2001 76.09 72.0001 74.97 72.0001Z"
        fill="url(#paint1_linear_51736_6310)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M74.97 71.5001H21.03C20.1247 71.5001 19.5 70.8662 19.5 70.2101V37.6001C19.5 36.9439 20.1247 36.3101 21.03 36.3101H74.97C75.8753 36.3101 76.5 36.9439 76.5 37.6001V70.2101C76.5 70.8662 75.8753 71.5001 74.97 71.5001Z"
        stroke="url(#paint2_linear_51736_6310)"
        strokeOpacity="0.1"
        strokeLinecap="round"
        shapeRendering="geometricPrecision"
      />
    </g>
    <g filter="">
      <path
        d="M38.06 29.8098H21.9C20.3 29.8098 19 28.5098 19 26.9098C19 25.3098 20.3 24.0098 21.9 24.0098H38.06C39.66 24.0098 40.96 25.3098 40.96 26.9098C40.96 28.5098 39.66 29.8098 38.06 29.8098Z"
        fill="url(#paint3_linear_51736_6310)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M38.06 29.3098H21.9C20.5761 29.3098 19.5 28.2336 19.5 26.9098C19.5 25.5859 20.5761 24.5098 21.9 24.5098H38.06C39.3839 24.5098 40.46 25.5859 40.46 26.9098C40.46 28.2336 39.3839 29.3098 38.06 29.3098Z"
        stroke="url(#paint4_linear_51736_6310)"
        strokeOpacity="0.1"
        strokeLinecap="round"
        shapeRendering="geometricPrecision"
      />
    </g>
    <g filter="">
      <path
        d="M48.0001 29.8C49.6017 29.8 50.9001 28.5016 50.9001 26.9C50.9001 25.2984 49.6017 24 48.0001 24C46.3985 24 45.1001 25.2984 45.1001 26.9C45.1001 28.5016 46.3985 29.8 48.0001 29.8Z"
        fill="url(#paint5_linear_51736_6310)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M50.4001 26.9C50.4001 28.2255 49.3256 29.3 48.0001 29.3C46.6746 29.3 45.6001 28.2255 45.6001 26.9C45.6001 25.5745 46.6746 24.5 48.0001 24.5C49.3256 24.5 50.4001 25.5745 50.4001 26.9Z"
        stroke="url(#paint6_linear_51736_6310)"
        strokeOpacity="0.1"
        strokeLinecap="round"
        shapeRendering="geometricPrecision"
      />
    </g>
    <rect x="23" y="44" width="50" height="20" rx="10" fill="#6274D0" />
    <g filter="">
      <mask id="path-10Inside-1_51736_6310" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.0901 49.5049C34.6783 49.5049 35.1551 49.9817 35.1551 50.5699V52.2761L36.748 51.3573C37.2575 51.0635 37.9088 51.2383 38.2027 51.7478C38.4966 52.2573 38.3218 52.9085 37.8123 53.2024L36.2217 54.1199L37.8123 55.0373C38.3218 55.3312 38.4966 55.9825 38.2027 56.492C37.9088 57.0015 37.2575 57.1763 36.748 56.8824L35.1551 55.9636V57.9299C35.1551 58.5181 34.6783 58.9949 34.0901 58.9949C33.502 58.9949 33.0251 58.5181 33.0251 57.9299V55.9636L31.4323 56.8824C30.9228 57.1763 30.2715 57.0015 29.9776 56.492C29.6837 55.9825 29.8585 55.3312 30.368 55.0373L31.9586 54.1199L30.368 53.2024C29.8585 52.9085 29.6837 52.2573 29.9776 51.7478C30.2715 51.2383 30.9228 51.0635 31.4323 51.3573L33.0251 52.2761V50.5699C33.0251 49.9817 33.502 49.5049 34.0901 49.5049ZM47.9998 49.5049C48.588 49.5049 49.0648 49.9817 49.0648 50.5699V52.2761L50.6577 51.3573C51.1672 51.0635 51.8185 51.2383 52.1123 51.7478C52.4062 52.2573 52.2314 52.9085 51.7219 53.2024L50.1313 54.1199L51.7219 55.0373C52.2314 55.3312 52.4062 55.9825 52.1123 56.492C51.8185 57.0015 51.1672 57.1763 50.6577 56.8824L49.0648 55.9636V57.9299C49.0648 58.5181 48.588 58.9949 47.9998 58.9949C47.4116 58.9949 46.9348 58.5181 46.9348 57.9299V55.9636L45.3419 56.8824C44.8324 57.1763 44.1812 57.0015 43.8873 56.492C43.5934 55.9825 43.7682 55.3312 44.2777 55.0373L45.8683 54.1199L44.2777 53.2024C43.7682 52.9085 43.5934 52.2573 43.8873 51.7478C44.1812 51.2383 44.8324 51.0635 45.3419 51.3573L46.9348 52.2761V50.5699C46.9348 49.9817 47.4116 49.5049 47.9998 49.5049ZM62.975 50.5699C62.975 49.9817 62.4981 49.5049 61.91 49.5049C61.3218 49.5049 60.845 49.9817 60.845 50.5699V52.2761L59.2521 51.3573C58.7426 51.0635 58.0913 51.2383 57.7974 51.7478C57.5035 52.2573 57.6783 52.9085 58.1878 53.2024L59.7784 54.1199L58.1878 55.0373C57.6783 55.3312 57.5035 55.9825 57.7974 56.492C58.0913 57.0015 58.7426 57.1763 59.2521 56.8824L60.845 55.9636V57.9299C60.845 58.5181 61.3218 58.9949 61.91 58.9949C62.4981 58.9949 62.975 58.5181 62.975 57.9299V55.9636L64.5678 56.8824C65.0773 57.1763 65.7286 57.0015 66.0225 56.492C66.3164 55.9825 66.1416 55.3312 65.6321 55.0373L64.0415 54.1199L65.6321 53.2024C66.1416 52.9085 66.3164 52.2573 66.0225 51.7478C65.7286 51.2383 65.0773 51.0635 64.5678 51.3573L62.975 52.2761V50.5699Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.0901 49.5049C34.6783 49.5049 35.1551 49.9817 35.1551 50.5699V52.2761L36.748 51.3573C37.2575 51.0635 37.9088 51.2383 38.2027 51.7478C38.4966 52.2573 38.3218 52.9085 37.8123 53.2024L36.2217 54.1199L37.8123 55.0373C38.3218 55.3312 38.4966 55.9825 38.2027 56.492C37.9088 57.0015 37.2575 57.1763 36.748 56.8824L35.1551 55.9636V57.9299C35.1551 58.5181 34.6783 58.9949 34.0901 58.9949C33.502 58.9949 33.0251 58.5181 33.0251 57.9299V55.9636L31.4323 56.8824C30.9228 57.1763 30.2715 57.0015 29.9776 56.492C29.6837 55.9825 29.8585 55.3312 30.368 55.0373L31.9586 54.1199L30.368 53.2024C29.8585 52.9085 29.6837 52.2573 29.9776 51.7478C30.2715 51.2383 30.9228 51.0635 31.4323 51.3573L33.0251 52.2761V50.5699C33.0251 49.9817 33.502 49.5049 34.0901 49.5049ZM47.9998 49.5049C48.588 49.5049 49.0648 49.9817 49.0648 50.5699V52.2761L50.6577 51.3573C51.1672 51.0635 51.8185 51.2383 52.1123 51.7478C52.4062 52.2573 52.2314 52.9085 51.7219 53.2024L50.1313 54.1199L51.7219 55.0373C52.2314 55.3312 52.4062 55.9825 52.1123 56.492C51.8185 57.0015 51.1672 57.1763 50.6577 56.8824L49.0648 55.9636V57.9299C49.0648 58.5181 48.588 58.9949 47.9998 58.9949C47.4116 58.9949 46.9348 58.5181 46.9348 57.9299V55.9636L45.3419 56.8824C44.8324 57.1763 44.1812 57.0015 43.8873 56.492C43.5934 55.9825 43.7682 55.3312 44.2777 55.0373L45.8683 54.1199L44.2777 53.2024C43.7682 52.9085 43.5934 52.2573 43.8873 51.7478C44.1812 51.2383 44.8324 51.0635 45.3419 51.3573L46.9348 52.2761V50.5699C46.9348 49.9817 47.4116 49.5049 47.9998 49.5049ZM62.975 50.5699C62.975 49.9817 62.4981 49.5049 61.91 49.5049C61.3218 49.5049 60.845 49.9817 60.845 50.5699V52.2761L59.2521 51.3573C58.7426 51.0635 58.0913 51.2383 57.7974 51.7478C57.5035 52.2573 57.6783 52.9085 58.1878 53.2024L59.7784 54.1199L58.1878 55.0373C57.6783 55.3312 57.5035 55.9825 57.7974 56.492C58.0913 57.0015 58.7426 57.1763 59.2521 56.8824L60.845 55.9636V57.9299C60.845 58.5181 61.3218 58.9949 61.91 58.9949C62.4981 58.9949 62.975 58.5181 62.975 57.9299V55.9636L64.5678 56.8824C65.0773 57.1763 65.7286 57.0015 66.0225 56.492C66.3164 55.9825 66.1416 55.3312 65.6321 55.0373L64.0415 54.1199L65.6321 53.2024C66.1416 52.9085 66.3164 52.2573 66.0225 51.7478C65.7286 51.2383 65.0773 51.0635 64.5678 51.3573L62.975 52.2761V50.5699Z"
        fill="url(#paint7_linear_51736_6310)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M35.1551 52.2761H34.1551V54.0074L35.6548 53.1424L35.1551 52.2761ZM36.748 51.3573L36.2484 50.4911V50.4911L36.748 51.3573ZM38.2027 51.7478L37.3364 52.2474V52.2474L38.2027 51.7478ZM37.8123 53.2024L38.3119 54.0686V54.0686L37.8123 53.2024ZM36.2217 54.1199L35.722 53.2537L34.2202 54.1199L35.722 54.9861L36.2217 54.1199ZM37.8123 55.0373L38.3119 54.1711V54.1711L37.8123 55.0373ZM36.748 56.8824L36.2484 57.7486L36.748 56.8824ZM35.1551 55.9636L35.6548 55.0974L34.1551 54.2324V55.9636H35.1551ZM33.0251 55.9636H34.0251V54.2324L32.5255 55.0974L33.0251 55.9636ZM31.4323 56.8824L30.9326 56.0162L30.9326 56.0162L31.4323 56.8824ZM29.9776 56.492L30.8438 55.9924L29.9776 56.492ZM30.368 55.0373L29.8684 54.1711H29.8684L30.368 55.0373ZM31.9586 54.1199L32.4583 54.9861L33.96 54.1199L32.4583 53.2537L31.9586 54.1199ZM30.368 53.2024L29.8684 54.0686H29.8684L30.368 53.2024ZM29.9776 51.7478L30.8438 52.2474H30.8438L29.9776 51.7478ZM31.4323 51.3573L30.9326 52.2236L30.9326 52.2236L31.4323 51.3573ZM33.0251 52.2761L32.5255 53.1424L34.0251 54.0074V52.2761H33.0251ZM49.0648 52.2761H48.0648V54.0074L49.5645 53.1424L49.0648 52.2761ZM50.6577 51.3573L51.1573 52.2236V52.2236L50.6577 51.3573ZM52.1123 51.7478L52.9786 51.2481L52.1123 51.7478ZM51.7219 53.2024L51.2223 52.3362L51.7219 53.2024ZM50.1313 54.1199L49.6317 53.2537L48.1299 54.1199L49.6317 54.9861L50.1313 54.1199ZM51.7219 55.0373L51.2223 55.9036L51.7219 55.0373ZM50.6577 56.8824L51.1573 56.0162V56.0162L50.6577 56.8824ZM49.0648 55.9636L49.5645 55.0974L48.0648 54.2324V55.9636H49.0648ZM46.9348 55.9636H47.9348V54.2324L46.4352 55.0974L46.9348 55.9636ZM45.3419 56.8824L44.8423 56.0162V56.0162L45.3419 56.8824ZM44.2777 55.0373L44.7773 55.9036L44.2777 55.0373ZM45.8683 54.1199L46.3679 54.9861L47.8697 54.1199L46.3679 53.2537L45.8683 54.1199ZM44.2777 53.2024L44.7773 52.3362L44.2777 53.2024ZM43.8873 51.7478L43.021 51.2481L43.8873 51.7478ZM45.3419 51.3573L44.8423 52.2236V52.2236L45.3419 51.3573ZM46.9348 52.2761L46.4352 53.1424L47.9348 54.0074V52.2761H46.9348ZM60.845 52.2761L60.3453 53.1424L61.845 54.0074V52.2761H60.845ZM59.2521 51.3573L59.7517 50.4911L59.2521 51.3573ZM58.1878 53.2024L57.6882 54.0686L58.1878 53.2024ZM59.7784 54.1199L60.2781 54.9861L61.7799 54.1199L60.2781 53.2537L59.7784 54.1199ZM58.1878 55.0373L58.6875 55.9036L58.1878 55.0373ZM59.2521 56.8824L59.7517 57.7486L59.2521 56.8824ZM60.845 55.9636H61.845V54.2324L60.3453 55.0974L60.845 55.9636ZM62.975 55.9636L63.4746 55.0974L61.975 54.2324V55.9636H62.975ZM64.5678 56.8824L65.0675 56.0162V56.0162L64.5678 56.8824ZM66.0225 56.492L65.1563 55.9924V55.9924L66.0225 56.492ZM65.6321 55.0373L65.1324 55.9036L65.1324 55.9036L65.6321 55.0373ZM64.0415 54.1199L63.5418 53.2537L62.0401 54.1199L63.5418 54.9861L64.0415 54.1199ZM65.6321 53.2024L65.1324 52.3362L65.1324 52.3362L65.6321 53.2024ZM66.0225 51.7478L65.1563 52.2474V52.2474L66.0225 51.7478ZM64.5678 51.3573L65.0675 52.2236L64.5678 51.3573ZM62.975 52.2761H61.975V54.0074L63.4746 53.1424L62.975 52.2761ZM36.1551 50.5699C36.1551 49.4294 35.2306 48.5049 34.0901 48.5049V50.5049C34.126 50.5049 34.1551 50.534 34.1551 50.5699H36.1551ZM36.1551 52.2761V50.5699H34.1551V52.2761H36.1551ZM36.2484 50.4911L34.6555 51.4099L35.6548 53.1424L37.2477 52.2236L36.2484 50.4911ZM39.0689 51.2481C38.4991 50.2602 37.2363 49.9213 36.2484 50.4911L37.2477 52.2236C37.2788 52.2056 37.3185 52.2163 37.3364 52.2474L39.0689 51.2481ZM38.3119 54.0686C39.2998 53.4988 39.6387 52.236 39.0689 51.2481L37.3364 52.2474C37.3544 52.2785 37.3437 52.3183 37.3126 52.3362L38.3119 54.0686ZM36.7213 54.9861L38.3119 54.0686L37.3126 52.3362L35.722 53.2537L36.7213 54.9861ZM38.3119 54.1711L36.7213 53.2537L35.722 54.9861L37.3126 55.9036L38.3119 54.1711ZM39.0689 56.9916C39.6387 56.0037 39.2998 54.7409 38.3119 54.1711L37.3126 55.9036C37.3437 55.9215 37.3544 55.9613 37.3364 55.9924L39.0689 56.9916ZM36.2484 57.7486C37.2363 58.3185 38.4991 57.9796 39.0689 56.9916L37.3364 55.9924C37.3185 56.0235 37.2788 56.0341 37.2477 56.0162L36.2484 57.7486ZM34.6555 56.8299L36.2484 57.7486L37.2477 56.0162L35.6548 55.0974L34.6555 56.8299ZM36.1551 57.9299V55.9636H34.1551V57.9299H36.1551ZM34.0901 59.9949C35.2306 59.9949 36.1551 59.0704 36.1551 57.9299H34.1551C34.1551 57.9658 34.126 57.9949 34.0901 57.9949V59.9949ZM32.0251 57.9299C32.0251 59.0704 32.9497 59.9949 34.0901 59.9949V57.9949C34.0542 57.9949 34.0251 57.9658 34.0251 57.9299H32.0251ZM32.0251 55.9636V57.9299H34.0251V55.9636H32.0251ZM31.9319 57.7486L33.5248 56.8299L32.5255 55.0974L30.9326 56.0162L31.9319 57.7486ZM29.1114 56.9916C29.6812 57.9796 30.944 58.3185 31.9319 57.7486L30.9326 56.0162C30.9015 56.0341 30.8618 56.0235 30.8438 55.9924L29.1114 56.9916ZM29.8684 54.1711C28.8805 54.7409 28.5415 56.0037 29.1114 56.9916L30.8438 55.9924C30.8259 55.9613 30.8366 55.9215 30.8677 55.9036L29.8684 54.1711ZM31.459 53.2537L29.8684 54.1711L30.8677 55.9036L32.4583 54.9861L31.459 53.2537ZM29.8684 54.0686L31.459 54.9861L32.4583 53.2537L30.8677 52.3362L29.8684 54.0686ZM29.1114 51.2481C28.5415 52.236 28.8805 53.4988 29.8684 54.0686L30.8677 52.3362C30.8366 52.3183 30.8259 52.2785 30.8438 52.2474L29.1114 51.2481ZM31.9319 50.4911C30.944 49.9213 29.6812 50.2602 29.1114 51.2481L30.8438 52.2474C30.8618 52.2163 30.9015 52.2056 30.9326 52.2236L31.9319 50.4911ZM33.5248 51.4099L31.9319 50.4911L30.9326 52.2236L32.5255 53.1424L33.5248 51.4099ZM32.0251 50.5699V52.2761H34.0251V50.5699H32.0251ZM34.0901 48.5049C32.9497 48.5049 32.0251 49.4294 32.0251 50.5699H34.0251C34.0251 50.534 34.0542 50.5049 34.0901 50.5049V48.5049ZM50.0648 50.5699C50.0648 49.4294 49.1403 48.5049 47.9998 48.5049V50.5049C48.0357 50.5049 48.0648 50.534 48.0648 50.5699H50.0648ZM50.0648 52.2761V50.5699H48.0648V52.2761H50.0648ZM50.158 50.4911L48.5652 51.4099L49.5645 53.1424L51.1573 52.2236L50.158 50.4911ZM52.9786 51.2481C52.4087 50.2602 51.1459 49.9213 50.158 50.4911L51.1573 52.2236C51.1884 52.2056 51.2282 52.2163 51.2461 52.2474L52.9786 51.2481ZM52.2216 54.0686C53.2095 53.4988 53.5484 52.236 52.9786 51.2481L51.2461 52.2474C51.264 52.2785 51.2534 52.3183 51.2223 52.3362L52.2216 54.0686ZM50.631 54.9861L52.2216 54.0686L51.2223 52.3362L49.6317 53.2537L50.631 54.9861ZM52.2216 54.1711L50.631 53.2537L49.6317 54.9861L51.2223 55.9036L52.2216 54.1711ZM52.9786 56.9916C53.5484 56.0037 53.2095 54.7409 52.2216 54.1711L51.2223 55.9036C51.2534 55.9215 51.264 55.9613 51.2461 55.9924L52.9786 56.9916ZM50.158 57.7486C51.1459 58.3185 52.4087 57.9796 52.9786 56.9916L51.2461 55.9924C51.2282 56.0235 51.1884 56.0341 51.1573 56.0162L50.158 57.7486ZM48.5652 56.8299L50.158 57.7486L51.1573 56.0162L49.5645 55.0974L48.5652 56.8299ZM50.0648 57.9299V55.9636H48.0648V57.9299H50.0648ZM47.9998 59.9949C49.1403 59.9949 50.0648 59.0704 50.0648 57.9299H48.0648C48.0648 57.9658 48.0357 57.9949 47.9998 57.9949V59.9949ZM45.9348 57.9299C45.9348 59.0704 46.8593 59.9949 47.9998 59.9949V57.9949C47.9639 57.9949 47.9348 57.9658 47.9348 57.9299H45.9348ZM45.9348 55.9636V57.9299H47.9348V55.9636H45.9348ZM45.8416 57.7486L47.4345 56.8299L46.4352 55.0974L44.8423 56.0162L45.8416 57.7486ZM43.021 56.9916C43.5909 57.9796 44.8537 58.3185 45.8416 57.7486L44.8423 56.0162C44.8112 56.0341 44.7714 56.0235 44.7535 55.9924L43.021 56.9916ZM43.778 54.1711C42.7901 54.7409 42.4512 56.0037 43.021 56.9916L44.7535 55.9924C44.7356 55.9613 44.7462 55.9215 44.7773 55.9036L43.778 54.1711ZM45.3686 53.2537L43.778 54.1711L44.7773 55.9036L46.3679 54.9861L45.3686 53.2537ZM43.778 54.0686L45.3686 54.9861L46.3679 53.2537L44.7773 52.3362L43.778 54.0686ZM43.021 51.2481C42.4512 52.236 42.7901 53.4988 43.778 54.0686L44.7773 52.3362C44.7462 52.3183 44.7356 52.2785 44.7535 52.2474L43.021 51.2481ZM45.8416 50.4911C44.8537 49.9213 43.5909 50.2602 43.021 51.2481L44.7535 52.2474C44.7714 52.2163 44.8112 52.2056 44.8423 52.2236L45.8416 50.4911ZM47.4345 51.4099L45.8416 50.4911L44.8423 52.2236L46.4352 53.1424L47.4345 51.4099ZM45.9348 50.5699V52.2761H47.9348V50.5699H45.9348ZM47.9998 48.5049C46.8593 48.5049 45.9348 49.4294 45.9348 50.5699H47.9348C47.9348 50.534 47.9639 50.5049 47.9998 50.5049V48.5049ZM61.91 50.5049C61.9459 50.5049 61.975 50.534 61.975 50.5699H63.975C63.975 49.4294 63.0504 48.5049 61.91 48.5049V50.5049ZM61.845 50.5699C61.845 50.534 61.8741 50.5049 61.91 50.5049V48.5049C60.7695 48.5049 59.845 49.4294 59.845 50.5699H61.845ZM61.845 52.2761V50.5699H59.845V52.2761H61.845ZM58.7524 52.2236L60.3453 53.1424L61.3446 51.4099L59.7517 50.4911L58.7524 52.2236ZM58.6637 52.2474C58.6816 52.2163 58.7213 52.2056 58.7524 52.2236L59.7517 50.4911C58.7638 49.9213 57.501 50.2602 56.9312 51.2481L58.6637 52.2474ZM58.6875 52.3362C58.6564 52.3183 58.6457 52.2785 58.6637 52.2474L56.9312 51.2481C56.3614 52.236 56.7003 53.4988 57.6882 54.0686L58.6875 52.3362ZM60.2781 53.2537L58.6875 52.3362L57.6882 54.0686L59.2788 54.9861L60.2781 53.2537ZM58.6875 55.9036L60.2781 54.9861L59.2788 53.2537L57.6882 54.1711L58.6875 55.9036ZM58.6637 55.9924C58.6457 55.9613 58.6564 55.9215 58.6875 55.9036L57.6882 54.1711C56.7003 54.7409 56.3614 56.0037 56.9312 56.9916L58.6637 55.9924ZM58.7524 56.0162C58.7213 56.0341 58.6816 56.0235 58.6637 55.9924L56.9312 56.9916C57.501 57.9796 58.7638 58.3185 59.7517 57.7486L58.7524 56.0162ZM60.3453 55.0974L58.7524 56.0162L59.7517 57.7486L61.3446 56.8299L60.3453 55.0974ZM61.845 57.9299V55.9636H59.845V57.9299H61.845ZM61.91 57.9949C61.8741 57.9949 61.845 57.9658 61.845 57.9299H59.845C59.845 59.0704 60.7695 59.9949 61.91 59.9949V57.9949ZM61.975 57.9299C61.975 57.9658 61.9459 57.9949 61.91 57.9949V59.9949C63.0504 59.9949 63.975 59.0703 63.975 57.9299H61.975ZM61.975 55.9636V57.9299H63.975V55.9636H61.975ZM65.0675 56.0162L63.4746 55.0974L62.4753 56.8299L64.0682 57.7486L65.0675 56.0162ZM65.1563 55.9924C65.1383 56.0235 65.0986 56.0341 65.0675 56.0162L64.0682 57.7486C65.0561 58.3185 66.3189 57.9796 66.8887 56.9916L65.1563 55.9924ZM65.1324 55.9036C65.1635 55.9215 65.1742 55.9613 65.1563 55.9924L66.8887 56.9917C67.4586 56.0037 67.1196 54.7409 66.1317 54.1711L65.1324 55.9036ZM63.5418 54.9861L65.1324 55.9036L66.1317 54.1711L64.5411 53.2537L63.5418 54.9861ZM65.1324 52.3362L63.5418 53.2537L64.5411 54.9861L66.1317 54.0686L65.1324 52.3362ZM65.1563 52.2474C65.1742 52.2785 65.1635 52.3182 65.1324 52.3362L66.1317 54.0687C67.1196 53.4988 67.4586 52.236 66.8887 51.2481L65.1563 52.2474ZM65.0675 52.2236C65.0986 52.2056 65.1383 52.2163 65.1563 52.2474L66.8887 51.2481C66.3189 50.2602 65.0561 49.9213 64.0682 50.4911L65.0675 52.2236ZM63.4746 53.1424L65.0675 52.2236L64.0682 50.4911L62.4753 51.4099L63.4746 53.1424ZM61.975 50.5699V52.2761H63.975V50.5699H61.975Z"
        fill="url(#paint8_linear_51736_6310)"
        fillOpacity="0.1"
        mask="url(#path-10Inside-1_51736_6310)"
      />
    </g>
    <defs>
      <filter
        id="filter0_di_51736_6310"
        x="19"
        y="35.8101"
        width="58"
        height="37.1899"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_6310"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_6310"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_6310"
        />
      </filter>
      <filter
        id="filter1_di_51736_6310"
        x="19"
        y="24.0098"
        width="21.96"
        height="6.7998"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_6310"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_6310"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_6310"
        />
      </filter>
      <filter
        id="filter2_di_51736_6310"
        x="45.1001"
        y="24"
        width="5.7998"
        height="6.7998"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_6310"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_6310"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_6310"
        />
      </filter>
      <filter
        id="filter3_di_51736_6310"
        x="29.835"
        y="49.5049"
        width="36.3301"
        height="10.4902"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_6310"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_6310"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_6310"
        />
      </filter>
      <linearGradient
        id="paint0_linear_51736_6310"
        x1="48"
        y1="18"
        x2="48"
        y2="78"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_51736_6310"
        x1="48"
        y1="35.8101"
        x2="48"
        y2="72.0001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_51736_6310"
        x1="48"
        y1="35.8101"
        x2="48"
        y2="72.0001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_51736_6310"
        x1="29.98"
        y1="24.0098"
        x2="29.98"
        y2="29.8098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_51736_6310"
        x1="29.98"
        y1="24.0098"
        x2="29.98"
        y2="29.8098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_51736_6310"
        x1="48.0001"
        y1="24"
        x2="48.0001"
        y2="29.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_51736_6310"
        x1="48.0001"
        y1="24"
        x2="48.0001"
        y2="29.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_51736_6310"
        x1="48"
        y1="49.5049"
        x2="48"
        y2="58.9949"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_51736_6310"
        x1="48"
        y1="49.5049"
        x2="48"
        y2="58.9949"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgPromoCodeReg;
